// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

export const ROUTE_NAMES = {
  ACCOUNT_STATEMENTS: 'account-statements'
}

const ROUTES = {
  [ROUTE_NAMES.ACCOUNT_STATEMENTS]: {
    name: ROUTE_NAMES.ACCOUNT_STATEMENTS,
    path: 'investors/account-statements'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.ACCOUNT_STATEMENTS].name,
    path: ROUTES[ROUTE_NAMES.ACCOUNT_STATEMENTS].path,
    component: (resolve) => require(['./views/account-statements.vue'], resolve)
  }
]
